import { useEffect, useState } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { InputField, Submitbtn } from "../../../Component";
import AddMoreBtn from "../../../Component/addMoreBtn";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { addCategory, getProductTypeList, set, uploadCategoryImage } from "../adminSlice";
import {
  validateAgeGrp,
  validateIsFileImageType,
} from "../../../Utils/validators";
import { validateIsFileImageTypeErrMsg } from "../../../Utils/errorMsg";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
const CreateCategory = () => {
  const initialVal = [
    {
      name: "",
      order: "",
      backImage: "",
      frontImage: "",
      seoName: "",
      frontImagePreview: "",
      backImagePreview: "",
    },
  ];
  const dispatch: Function = useDispatch<AppDispatch>();
  const [categoryArr, setCategoryArr] = useState<any>(initialVal);
  const [productTypeList, setProductTypeList] = useState<any>([]);
  const [productType, setProductType] = useState<any>("");
  useEffect(() => {
    dispatch(
      getProductTypeList({
        callback: (res: any) => {
          setProductTypeList(res?.data);
          if (res?.status === "success") {
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.msg, type: error?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  }, []);
  const onPressAdd = () => {
    setCategoryArr([...categoryArr, initialVal[0]]);
  };
  const handleClose = (index: any) => {
    const newArrr = [...categoryArr];
    if (index > -1) {
      newArrr.splice(index, 1);
    }
    setCategoryArr(newArrr);
  };
  const onchangeProductType = (value: any) => {
    setProductType(value);
  };
  function onchangeCategory(val: any, index: any, key: any) {
    let newArr = JSON.parse(JSON.stringify(categoryArr));
    const mediaTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
    if (key === "frontImage") {
      if (!validateIsFileImageType(val)) {
        return;
      } else {

        const reader = new FileReader();
        const file = val.target.files[0];
        if (!mediaTypes.includes(file.type)) {
          console.error("Unsupported file type:", file.type);
          return;
        }
        reader.onloadend = () => {
          newArr[index]["frontImagePreview"] = reader.result;
          setCategoryArr(newArr);
        };
        reader.readAsDataURL(file);

        dispatch(
          uploadCategoryImage({
            params: { file: file, },
            callback: (res: any) => {
              if (res?.data) {
                newArr[index][key] = res?.data?.name;
                setCategoryArr(newArr);
              }
            },
            errorCallback: () => { },
          })
        );
      }
    } else if (key === "backImage") {
      if (!validateIsFileImageType(val)) {
        return;
      } else {
        const reader = new FileReader();
        const file = val.target.files[0];
        if (!mediaTypes.includes(file.type)) {
          console.error("Unsupported file type:", file.type);
          return;
        }
        reader.onloadend = () => {
          newArr[index]["backImagePreview"] = reader.result;
          setCategoryArr(newArr);
        };
        reader.readAsDataURL(file);
        dispatch(
          uploadCategoryImage({
            params: file,
            callback: (res: any) => {
              if (res?.data) {
                newArr[index][key] = res?.data?.name;
                setCategoryArr(newArr);
              }
            },
            errorCallback: () => { },
          })
        );
      }
    } else if (key === "name") {
      newArr[index][key] = val;
      setCategoryArr(newArr);
    } else if (key === "order") {
      if (validateAgeGrp(val)) {
        newArr[index][key] = val;
        setCategoryArr(newArr);
      }
    } else if (key === "seoName") {
      newArr[index][key] = val;
      setCategoryArr(newArr);
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const updatedProduct = categoryArr.map((item: any) => { const { frontImagePreview, backImagePreview, ...rest } = item; return rest });
    if (validations()) {
      return;
    } else {
      const postData = {
        productTypeId: productType?._id,
        book: updatedProduct,
      };
      dispatch(
        addCategory({
          params: postData,
          callback: (res: any) => {
            if (res?.status === "success") {
              setCategoryArr(initialVal);
              setProductType("");
              dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
              setTimeout(() => {
                hideSnackbar();
              }, 5000);
            }
          },
          errorCallback: (error: any) => {
            dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          },
        })
      );
    }
  };
  const validations = () => {
    let valid = false;
    categoryArr.map((item: any) => {
      if (
        item?.name === "" ||
        item?.order === "" ||
        item?.frontImagePreview === "" ||
        item?.backImagePreview === "" ||
        item?.seoName === ""
      ) {
        valid = true;
      }
    });
    if (productType === "") {
      valid = true;
    }
    return valid;
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle name={"Create Category "} />
      </div>
      <div className="formDiv">
        <form onSubmit={handleSubmit}>
          <div className="row bxshadow p-2 borderRadius mb-4 w-75">
            <div className="col-md-4">
              <LabelInput labelName={"Product Type"} isRequired />
              <DropdownWithClear
                labelName={"Select Product Type"}
                setInputText={(value: any) => onchangeProductType(value)}
                options={productTypeList}
                value={productType}
              />
            </div>
          </div>
          {categoryArr.map((item: any, index: any) => {
            return (
              <div className="row bxshadow p-2 borderRadius mb-4 w-75 position-relative">
                <div className="col-md-4 mb-3">
                  <LabelInput labelName={"Category"} isRequired />
                  <InputField
                    // key={"ex2"}
                    placeholder={"Enter Category"}
                    setInputText={(value: any) =>
                      onchangeCategory(value, index, "name")
                    }
                    value={item.name}
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <LabelInput labelName={"Order number"} isRequired />
                  <InputField
                    // key={"ex2"}
                    placeholder={`Order  No. ${index + 1}`}
                    setInputText={(value: any) =>
                      onchangeCategory(value, index, "order")
                    }
                    value={item.order}
                    maxLength={2}
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <LabelInput labelName={"SEO Name"} isRequired />
                  <InputField
                    key={"ex2"}
                    placeholder={"Enter SEO Name"}
                    setInputText={(value: any) =>
                      onchangeCategory(value, index, "seoName")
                    }
                    value={item?.seoName}
                  />
                </div>
                <div className="col-md-2 mb-3">
                  <LabelInput labelName={"Front Image"} isRequired />
                  <ImagePickerAndViewer
                    value={item?.frontImagePreview}
                    handleChange={(value: any) => onchangeCategory(value, index, "frontImage")}
                    htmlFor={`frontImage-uploadFront-${index}`}
                    doctype={""}
                  />
                </div>
                <div className="col-md-2 mb-3">
                  <LabelInput labelName={"Back Image"} isRequired />
                  <ImagePickerAndViewer
                    value={item?.backImagePreview}
                    handleChange={(value: any) => onchangeCategory(value, index, "backImage")}
                    htmlFor={`backImage-uploadBack-${index}`}
                    doctype={""}
                  />
                </div>
                {index === categoryArr.length - 1 && (
                  <div className="col-md-2 mb-3 position-relative">
                    <div className="position-absolute bottom-0">
                      <AddMoreBtn handleClick={onPressAdd} />
                    </div>
                  </div>
                )}
                {
                  categoryArr.length === 1 ? null : (
                    <div className="col-1 position-absolute end-0 text-end">
                      <DeleteForeverIcon
                        className="cursor"
                        color="error"
                        fontSize="medium"
                        onClick={() => handleClose(index)}
                      />
                    </div>
                  )
                }
              </div>
            );
          })}
          <div className="col-md-10">
            <div className="col-md-3 mx-auto">
              <Submitbtn name={"Submit"} disabled={validations()} />
            </div>
          </div>
        </form>
      </div >
    </div >
  );
};

export default CreateCategory;
